import { render, staticRenderFns } from "./secition-card.vue?vue&type=template&id=9a13cb62"
import script from "./secition-card.vue?vue&type=script&lang=js"
export * from "./secition-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports